import React from "react";
import PrivateRoute from "common/routes/PrivateRoute/PrivateRoute";

export default function ProveedorProtectedRoute(props){
    return <PrivateRoute allowedroles={["proveedor"]}>
        {props.children}
    </PrivateRoute>;
}